import { render, staticRenderFns } from "./PreviewRes.vue?vue&type=template&id=1ad5adf6&scoped=true&"
import script from "./PreviewRes.vue?vue&type=script&lang=js&"
export * from "./PreviewRes.vue?vue&type=script&lang=js&"
import style0 from "./PreviewRes.vue?vue&type=style&index=0&id=1ad5adf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad5adf6",
  null
  
)

export default component.exports